import { FILTER_FEATURE } from "api/ApiPath";
import { BaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/BaseApiResponseModel";
import { ListBaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/ListBaseApiResponseModel";
import { BaseFilterListRequestModel } from "app/based/baseApiModel/baseFilterListModel/BaseFilterListRequestModel";
import { BaseFilterListResponseModel } from "app/based/baseApiModel/baseFilterListModel/BaseFilterListResponseModel";
import { FilterInjection } from "app/filters/di/FilterInjection";
import { StoreInjection } from "features/storeManagement/di/StoreInjection";
import { injectable } from "tsyringe";
import { paramsChecking } from "utils/helpersInTs/helpersInTs";
import { StoreFormRequestEntity } from "../entities/StoreFormRequestEntity";
import { StoreRequestEntity } from "../entities/StoreRequestEntity";
import { StoreResponseEntity } from "../entities/StoreResponseEntity";
import { IStoreRepository } from "../repositories/IStoreRepository";

@injectable()
export class StoreUseCase {
  private storeRepo: IStoreRepository;

  constructor() {
    this.storeRepo = StoreInjection.getRepo();
  }

  private checkParams(values: StoreRequestEntity): StoreRequestEntity {
    return {
      ...values,
      status: paramsChecking(values?.status, "select"),
      phone: paramsChecking(values?.phone, "input"),
      partnerCode: paramsChecking(values?.partnerCode, "input"),
    };
  }

  async getStores(
    params: StoreRequestEntity,
  ): Promise<ListBaseApiResponseModel<StoreResponseEntity>> {
    const updatedParams = this.checkParams(params);
    return await this.storeRepo.getStores(updatedParams);
  }

  async getStoreDetail(
    code: string,
  ): Promise<BaseApiResponseModel<StoreResponseEntity>> {
    return await this.storeRepo.getStoreDetail(code);
  }

  async createStore(
    body: StoreFormRequestEntity,
  ): Promise<BaseApiResponseModel<StoreResponseEntity>> {
    return await this.storeRepo.createStore(body);
  }

  async updateStore(
    body: StoreFormRequestEntity,
  ): Promise<BaseApiResponseModel<StoreResponseEntity>> {
    return await this.storeRepo.updateStore(body);
  }

  async deleteStore(
    code: string,
  ): Promise<BaseApiResponseModel<StoreResponseEntity>> {
    return await this.storeRepo.deleteStore(code);
  }

  async getPartnerList(
    params: BaseFilterListRequestModel,
  ): Promise<Array<BaseFilterListResponseModel>> {
    const filterUseCase = FilterInjection.getUseCase();
    return await filterUseCase.fetchListWithFeature<
      BaseFilterListRequestModel,
      BaseFilterListResponseModel
    >({
      path: FILTER_FEATURE.PARTNER_LIST,
      isNeedFeature: true,
      params,
      capabilityKey: "filter.partner",
    });
  }
}
